export default __webpack_public_path__ + "static/media/GOV.CO_Logo-whiteGOV.CO_Logo-white.e4b37723.png";